export const transformEditUrl = (originalUrl: string): string => {
// Разделяем URL на путь и параметры запроса
  const [path, queryString] = originalUrl.split('?')

  // Разбиваем путь на части и фильтруем пустые элементы
  const pathParts = path.split('/').filter(part => part !== '')

  // Извлекаем UUID (4-й элемент в массиве)
  const uuid = pathParts[3]

  // Создаем новый путь в формате /directory/insurances/UUID
  const newPath = `/${pathParts[0]}/${pathParts[1]}/${uuid}`

  // Если есть параметры запроса, добавляем их
  const newQuery = queryString ? `${queryString}&tab=edit` : 'tab=edit'

  // Собираем итоговый URL
  return `${newPath}?${newQuery}`
}
